import { render } from "./WidgetDxImage.vue?vue&type=template&id=3acdaedc"
import script from "./WidgetDxImage.vue?vue&type=script&lang=js"
export * from "./WidgetDxImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__